import { Address } from './Address';
import { File } from './File';

import { EnterpriseDTO } from 'src/dtos/EnterpriseDTO';
import { AddressDTO } from 'src/dtos/AddressDTO';

export class EnterpriseData {
  public name!: string;
  public address!: Address;
  public currencyId!: number;
  public lineckerCustomerNo?: string;
  public stripeCustomerId?: string;
  public phoneNumber!: string;
  public email!: string;
  public website?: string;
  public vatId?: string;
  public vatIdLastCheckedUTC?: Date;
  public isVatIdValid?: boolean;
  public logoUrl?: string;
  public isDemo!: boolean;

  public salutationId!: number;
  public companyName!: string;
  public billingAddressVatId?: string;
  public billingAddressVatIdLastCheckedUTC?: Date;
  public billingAddressVatIdValid?: boolean;
  public billingAddress!: Address;
  public title!: string;
  public firstName!: string;
  public lastName!: string;
  public billingAddressEmailAddress!: string;
  public hasBillingAddress: boolean;

  public paymentViaHogast: boolean;
  public hogastCompanyId?: number;
  public hogastCustomerId?: string;

  constructor(enterpriseDTO: EnterpriseDTO) {
    this.name = enterpriseDTO.name;
    this.address = {
      street: enterpriseDTO.address.addressLine01,
      zip: enterpriseDTO.address.zip,
      city: enterpriseDTO.address.city,
      countryCode: enterpriseDTO.address.countryCode,
    };
    this.currencyId = enterpriseDTO.currencyId;
    this.lineckerCustomerNo = enterpriseDTO.lineckerCustomerNo;
    this.stripeCustomerId = enterpriseDTO.stripeCustomerNo;
    this.phoneNumber = enterpriseDTO.phoneNumber;
    this.email = enterpriseDTO.emailAddress;
    this.website = enterpriseDTO.website;
    this.vatId = enterpriseDTO.vatId;
    if (enterpriseDTO.vatIdLastCheckedUTC) {
      this.vatIdLastCheckedUTC = new Date(
        enterpriseDTO.vatIdLastCheckedUTC + 'Z'
      );
    }
    this.isVatIdValid = enterpriseDTO.vatIdValid;

    if (enterpriseDTO.logoFile) {
      this.logoUrl = new File(enterpriseDTO.logoFile).url;
    }

    this.isDemo = enterpriseDTO.isDemo;
    this.salutationId = enterpriseDTO.salutationId;
    this.companyName = enterpriseDTO.companyName ?? '';
    this.billingAddressVatId = enterpriseDTO.billingAddressVatId;
    if (enterpriseDTO.billingAddressVatIdLastCheckedUTC) {
      this.billingAddressVatIdLastCheckedUTC = new Date(
        enterpriseDTO.billingAddressVatIdLastCheckedUTC + 'Z'
      );
    }
    this.billingAddressVatIdValid = enterpriseDTO.billingAddressVatIdValid;
    this.billingAddress = {
      street: enterpriseDTO.billingAddress.addressLine01,
      zip: enterpriseDTO.billingAddress.zip,
      city: enterpriseDTO.billingAddress.city,
      countryCode: enterpriseDTO.billingAddress.countryCode,
    };
    this.title = enterpriseDTO.titles;
    this.firstName = enterpriseDTO.firstName;
    this.lastName = enterpriseDTO.lastName;
    this.billingAddressEmailAddress = enterpriseDTO.billingAddressEmailAddress;
    this.hasBillingAddress = enterpriseDTO.hasBillingAddress;

    this.paymentViaHogast = enterpriseDTO.paymentViaHogast;
    this.hogastCompanyId = enterpriseDTO.hogastCompanyId;
    this.hogastCustomerId = enterpriseDTO.hogastCustomerId;
  }

  public static convertPartialEnterpriseDataToPartialEnterpriseDTO(
    enterpriseData: Partial<EnterpriseData>
  ): Partial<EnterpriseDTO> {
    const enterpriseDTO: Partial<EnterpriseDTO> = {};

    if (enterpriseData.address != undefined) {
      enterpriseDTO.address = new AddressDTO(enterpriseData.address);
    }
    if (enterpriseData.name !== undefined) {
      enterpriseDTO.name = enterpriseData.name;
    }
    if (enterpriseData.vatId !== undefined) {
      enterpriseDTO.vatId = enterpriseData.vatId;
    }
    if (enterpriseData.currencyId !== undefined) {
      enterpriseDTO.currencyId = enterpriseData.currencyId;
    }
    if (enterpriseData.phoneNumber !== undefined) {
      enterpriseDTO.phoneNumber = enterpriseData.phoneNumber;
    }
    if (enterpriseData.email !== undefined) {
      enterpriseDTO.emailAddress = enterpriseData.email;
    }
    if (enterpriseData.website !== undefined) {
      enterpriseDTO.website = enterpriseData.website;
    }
    if (enterpriseData.lineckerCustomerNo !== undefined) {
      enterpriseDTO.lineckerCustomerNo = enterpriseData.lineckerCustomerNo;
    }
    if (enterpriseData.stripeCustomerId !== undefined) {
      enterpriseDTO.stripeCustomerNo = enterpriseData.stripeCustomerId;
    }

    if (enterpriseData.salutationId !== undefined) {
      enterpriseDTO.salutationId = enterpriseData.salutationId;
    }
    if (enterpriseData.companyName !== undefined) {
      enterpriseDTO.companyName = enterpriseData.companyName;
    }
    if (enterpriseData.hasBillingAddress !== undefined) {
      enterpriseDTO.hasBillingAddress = enterpriseData.hasBillingAddress;
    }
    if (enterpriseData.billingAddressVatId !== undefined) {
      enterpriseDTO.billingAddressVatId = enterpriseData.billingAddressVatId;
    }
    if (enterpriseData.billingAddress !== undefined) {
      enterpriseDTO.billingAddress = new AddressDTO(
        enterpriseData.billingAddress
      );
    }
    if (enterpriseData.title !== undefined) {
      enterpriseDTO.titles = enterpriseData.title;
    }
    if (enterpriseData.firstName !== undefined) {
      enterpriseDTO.firstName = enterpriseData.firstName;
    }
    if (enterpriseData.lastName !== undefined) {
      enterpriseDTO.lastName = enterpriseData.lastName;
    }
    if (enterpriseData.billingAddressEmailAddress !== undefined) {
      enterpriseDTO.billingAddressEmailAddress =
        enterpriseData.billingAddressEmailAddress;
    }

    if (enterpriseData.paymentViaHogast !== undefined) {
      enterpriseDTO.paymentViaHogast = enterpriseData.paymentViaHogast;
    }
    if (enterpriseData.hogastCompanyId !== undefined) {
      enterpriseDTO.hogastCompanyId = enterpriseData.hogastCompanyId;
    }
    if (enterpriseData.hogastCustomerId !== undefined) {
      enterpriseDTO.hogastCustomerId = enterpriseData.hogastCustomerId;
    }
    if (enterpriseData.isDemo !== undefined) {
      enterpriseDTO.isDemo = enterpriseData.isDemo;
    }

    return enterpriseDTO;
  }
}
